import { render } from "./EmberPage.vue?vue&type=template&id=7d2574dd&scoped=true"
import script from "./EmberPage.vue?vue&type=script&lang=js"
export * from "./EmberPage.vue?vue&type=script&lang=js"

import "./EmberPage.vue?vue&type=style&index=0&id=7d2574dd&lang=scss&scoped=true"
import "./EmberPage.vue?vue&type=style&index=1&id=7d2574dd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2574dd"]])

export default __exports__